import React from 'react'

import PropTypes from 'prop-types'

import { useT } from '@galo-monitor/i18n'
import { user } from '@galo-monitor/icons'
import { colors } from '@galo-monitor/styles'
import Icon from '@galo-monitor/web-components/Icon'

import IconButton from '../IconButton'

const UserIconButton = ({ iconColor, ...props }) => {
  const t = useT()
  return (
    <IconButton tooltip={ t('user', { howMany: 1 }) } { ...props }>
      <Icon icon={ user } color={ iconColor } />
    </IconButton>
  )
}

UserIconButton.propTypes = {
  iconColor: PropTypes.string
}

UserIconButton.defaultProps = {
  iconColor: colors.mutedText
}

export default UserIconButton
